export const TAX_ID = {
    ALB: 'Numri i identifikimit fiskal',
    AND: 'Número d\'identificació fiscal',
    ARE: 'الرقم الضريبي',
    AUT: 'Steuernummer',
    BEL: 'Numéro d\'identification fiscale',
    BGR: 'Данъчен номер',
    BIH: 'JIB',
    CHE: 'Steuernummer',
    CYP: 'Αριθμός Φορολογικού Μητρώου',
    CZE: 'DIČ',
    DEU: 'Steuernummer',
    DNK: 'CPR-nummer',
    DZA: 'Numéro d\'identification fiscale',
    EGY: 'الرقم الضريبي',
    ESP: 'Número de identificación fiscal',
    EST: 'Maksukohustuslase number',
    FIN: 'Veronumero',
    FRA: 'Numéro d\'identification fiscale',
    GBR: 'Tax Identification Number',
    GRC: 'Αριθμός Φορολογικού Μητρώου',
    HRV: 'OIB',
    HUN: 'Adószám',
    IRL: 'Tax Reference Number',
    ITA: 'Codice fiscale',
    JOR: 'رقم الضريبة',
    LIE: 'Steuernummer',
    LTU: 'Mokesčių mokėtojo kodas',
    LUX: 'Numéro d\'identification fiscale',
    LVA: 'Nodokļu maksātāja kods',
    MAR: 'Numéro d\'identification fiscale',
    MCO: 'Numéro fiscal',
    MKD: 'Даночен број',
    MLT: 'Tax Identification Number',
    MNE: 'Poreski broj',
    NLD: 'Fiscaal nummer',
    NOR: 'Skattenummer',
    POL: 'Numer identyfikacji podatkowej',
    PRT: 'Número de Identificação Fiscal',
    QAT: 'رقم التعريف الضريبي',
    ROU: 'Cod de identificare fiscală',
    SRB: 'PIB',
    SVK: 'DIČ',
    SVN: 'Davčna številka',
    SWE: 'Skattenummer',
    TUR: 'Vergi numarası',
    UKR: 'ІПН',
};
